import axios from 'axios';
import { toast } from 'components/elements/molecules/Toast/Toast';
import { updatePropagateStatus } from './classRooms';

export function syncCourses(payload) {
  return (dispatch) => {
    return axios
      .post('/api/duplicateCourse/syncCourses', payload)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((error) => {
        console.log('Error while syncing course', error);
        toast('Error while syncing course', {
          type: 'error',
        });
        throw error;
      });
  };
}

export function syncMasterCourses(payload) {
  return (dispatch) => {
    dispatch(updatePropagateStatus(payload.masterCourseId, false));

    return axios
      .post('/api/duplicateCourse/syncMasterCourses', payload)
      .then((res) => {
        const data = res.data;

        return data;
      })
      .catch((error) => {
        console.log('Error while syncing master course', error);
        toast('Error while syncing master course', {
          type: 'error',
        });
        throw error;
      });
  };
}
